import React, { Fragment } from 'react';
import { roundTo2Digits } from '~/utils/format';
let appsflyerID =
  process.env.CHOWBUS_ENV !== 'production'
    ? '4ebc6db5-acec-4bba-a176-a17d7fd5ca4d'
    : 'f9b4cc68-1613-4dba-aabf-58276284106b';
let WEB_DEV_KEY = process.env.CHOWBUS_ENV !== 'production' ? "0fa3823c-06eb-4d47-a36e-5437232930c1" : "d40febe1-4397-4561-a48a-db9052ed042b";


export const Appsflyer = () => {
  return (
    <Fragment>
      <script
        dangerouslySetInnerHTML={{
          __html: `
!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF", "pba,banners",{pba: {webAppId: "${WEB_DEV_KEY}"}, banners: {key: "${appsflyerID}"}});
var pathShouldShowBanner = true;
var excludePath = ['/driver-app-download','/restaurant-app-download','/download'];
if(excludePath.indexOf(document.location.pathname)!==-1||document.location.href.indexOf('pos')!==-1){
  pathShouldShowBanner = false;
}
((!/alipay/.test(window.navigator.userAgent.toLowerCase()))&&(pathShouldShowBanner))&&AF('banners', 'showBanner');
`,
        }}></script>
    </Fragment>
  );
};


function trackWebCompleteRegister(provider) {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'complete_registration',
    eventValue: { registration_method: provider },

  });
}

function trackWebStartSession() {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'web_start_session',
    eventValue: {},
  });
}

function trackWebAddToCart(eventData) {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'add_to_cart',
    eventValue: {
      ...eventData
    },
  });
}

function trackWebInitiatedCheckout(eventData) {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'initiated_checkout',
    eventValue: {
      ...eventData
    },
  });
}

function trackWebPurchase(eventData) {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'web_purchase',
    eventValue: {
      ...eventData
    },
  });
}

function trackWebFirstPurchase(eventData) {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'web_first_purchase',
    eventValue: {
      ...eventData
    },
  });
}

function trackWebOrderCancelled(eventData) {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'order_cancelled',
    eventValue: {
      ...eventData
    },
  });
}

function trackWebMembershipSubscribe() {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'membership_subscribe',
    eventValue: {},
  });
}

function trackWebmembershipUnsubscribe(eventData) {
  window.AF && AF('pba', 'event', {
    eventType: 'EVENT',
    eventName: 'membership_unsubscribe',
    eventValue: { ...eventData },
  });
}

function disableSmartBanner() {
  window.AF && AF('banners', 'hideBanner');
}


function enableSmartBanner() {
  if (!/alipay/.test(window.navigator.userAgent.toLowerCase())) {
    window.AF && AF('banners', 'showBanner');
  } else {
    window.AF && AF('banners', 'hideBanner');
  }

}

function mealObjecConvertFromStore(itemMeal) {
  let { id, quantity, attributes, relationships, customizationOptions } = itemMeal;
  let { name, price, foreignName } = attributes;
  let { name: categoryName } = relationships?.category?.data?.attributes || {};
  let customizationAmount = 0;
  customizationAmount = (Object.keys(customizationOptions).reduce((customizationAmount, customiazationOptionKey) => {
    let { quantity, attributes } = customizationOptions[customiazationOptionKey];
    let { price } = attributes;
    customizationAmount = customizationAmount + quantity * parseFloat(price);
    return customizationAmount;
  }, customizationAmount));
  let subTotal = parseFloat(roundTo2Digits(customizationAmount * quantity + quantity * price));
  return {
    subTotal,
    category: categoryName,
    sku: id,
    quantity: quantity,
    name: name,
    foreignName,
    price: parseFloat(roundTo2Digits(1 * price)),
  };
};

function getMeal(itemMeal) {

  return mealObjecConvertFromStore(itemMeal);
}

//add_to_cart
//initiated_checkout
//web_purchase
//web_first_purchase
//
export const AppsflyerPBA = {
  trackWebCompleteRegister,
  trackWebStartSession,
  trackWebAddToCart,
  trackWebInitiatedCheckout,
  trackWebPurchase,
  trackWebFirstPurchase,
  trackWebOrderCancelled,
  trackWebMembershipSubscribe,
  trackWebmembershipUnsubscribe,
  disableSmartBanner,
  enableSmartBanner,

  getMeal,
}


